/**
 * @fileoverview Agent definition for weave-snapshotter-v2.
 *
 * Synthesizes continuity data by analyzing a chapter against structural
 * planning entities (storylines, character arcs, plot threads). Runs as
 * Stage 2 of the snapshot pipeline after plot and character snapshotters.
 *
 * @category narrative.continuity.analysis
 * @type primitive
 */

import type { AppAgentDefinition } from '@/domains/agents/schemas';
import { InputSchema, OutputSchema } from './schema';
import { prompt } from './prompt';

// =============================================================================
// AGENT DEFINITION
// =============================================================================

export const definition: AppAgentDefinition = {
  id: 'weave-snapshotter-v2',
  kind: 'primitive',
  name: 'Weave Snapshotter',
  description: 'Synthesizes continuity data by analyzing a chapter against storylines and character arcs. Plot threads provided as read-only context.',
  category: 'structure',
  defaultPrompt: prompt,
  inputSchema: InputSchema,
  outputSchema: OutputSchema,

  // --- Metadata (Hybrid Architecture) ---
  metadata: {
    status: 'active',
    type: 'primitive',
    addedIn: '2026-02',
    lastUpdated: '2026-02',
    taxonomyPath: 'narrative.continuity.analysis',
    usedBy: [
      'use-weave-snapshotter-v2.ts',
    ],
    usedInComposites: [],
    relatedAgents: [
      'plot-snapshotter-v2',
      'character-snapshotter-single-v2',
    ],
  },
};
